<template>
  <div class="connect-exchanges-content-description">
    <div class="connect-exchanges-content-description__title">
      {{ title }}
    </div>
    <div class="connect-exchanges-content-description__subtitle">
      {{ subtitle }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ConnectExchangesContentDescription",
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.connect-exchanges-content-description {
  font-family: sans-serif;
  font-size: 2.125rem;
  font-weight: bold;

  &__subtitle {
    font-family: sans-serif;
    font-size: 1rem;
    font-weight: 400;
  }
}
@media(max-width:768px) {
  .connect-exchanges-content-description {
    font-size: 1.2rem;

    &__subtitle {
      font-family: sans-serif;
      padding-top: 0.5rem;
      font-size: 0.8rem;
      font-weight: 400;
    }
  }
}
</style>